var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipmentCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E50B20",
    d: "M4.034 4.034c.343-.344.887-.379 1.27-.087l.099.087L10 8.63l4.597-4.597c.353-.353.91-.377 1.29-.071l.08.07c.343.344.378.888.076 1.283l-.077.087L11.37 10l4.597 4.597c.353.353.377.91.071 1.29l-.07.08c-.344.343-.888.378-1.283.077l-.087-.078-4.598-4.597-4.596 4.597c-.353.353-.91.377-1.29.071l-.08-.07c-.343-.344-.378-.888-.076-1.283l.077-.087L8.63 10 4.034 5.403c-.353-.353-.377-.91-.071-1.29l.07-.08z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E50B20",
    fillRule: "evenodd",
    d: "M3.857 3.857c.432-.432 1.116-.476 1.598-.109l.014.01.111.098L10 8.278l4.42-4.421c.444-.444 1.146-.474 1.624-.089l.011.009.088.08c.434.434.475 1.118.1 1.61l-.006.007-.093.106L11.721 10l4.421 4.42c.444.444.474 1.146.089 1.624l-.009.011-.08.088c-.434.434-1.118.475-1.61.1l-.007-.006-.106-.093L10 11.721l-4.42 4.421c-.444.444-1.146.474-1.624.089l-.011-.009-.088-.08c-.434-.434-.475-1.118-.1-1.61l.006-.007.093-.106L8.276 10l-4.42-4.42c-.443-.444-.473-1.146-.088-1.624l.009-.011.08-.088zM8.63 10l-4.596 4.597-.077.087c-.302.395-.267.939.077 1.282l.078.071c.38.306.938.282 1.291-.07l4.596-4.598 4.598 4.597.087.078c.395.3.939.266 1.282-.078l.071-.078c.306-.38.282-.938-.07-1.291L11.368 10l4.597-4.597.077-.087c.302-.395.267-.939-.077-1.282l-.078-.071c-.38-.306-.938-.282-1.291.07L10 8.632 5.403 4.034l-.099-.087c-.383-.292-.927-.257-1.27.087l-.071.078c-.306.38-.282.938.07 1.291L8.63 10z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentCancelIcon);
export default __webpack_public_path__ + "static/media/shipment-cancel-icon.a44393587ab96d5b4f900dccb6a5629e.svg";
export { ForwardRef as ReactComponent };